// Copied from vendor-ref/mara/app/ui/src/theme.js (definePreset(Aura, ...)); values unchanged, only typed.
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';

export default definePreset(Aura, {
  semantic: {
    disabledOpacity: '0.5',
    primary: {
      50: '#F5F2FF',
      100: '#EBE8FF',
      200: '#D9D4FF',
      300: '#BFB1FF',
      400: '#9F85FF',
      500: '#7C4CFF',
      600: '#7230F7',
      700: '#641EE3',
      800: '#5318BF',
      900: '#45169C',
      950: '#290B6A',
    },
    colorScheme: {
      light: {
        maraBlue: '#2c69ed',
        maraPink: '#b65be6',
        xr: 'rgba(255, 255, 255, 0.75)',
        content: { background: '{surface.50}' },
        surfaceGround: '{surface.200}',
        surfaceSection: '{surface.100}',
        formField: { borderColor: '{surface.200}', hoverBorderColor: '{surface.300}', disabledBackground: '{surface.100}' },
      },
      dark: {
        maraBlue: '#124fd2',
        maraPink: '#a12ddf',
        xr: 'rgba(0, 0, 0, 0.75)',
        content: { background: '{surface.900}', borderColor: '{surface.800}' },
        surfaceGround: '{surface.950}',
        surfaceSection: '{surface.800}',
        formField: { borderColor: '{surface.800}', hoverBorderColor: '{surface.700}', disabledBackground: '{surface.900}' },
        overlay: { modal: { borderColor: '{surface.800}' }, popover: { borderColor: '{surface.800}' } },
      },
    },
    formField: { paddingX: '1rem' },
    overlay: { popover: { borderRadius: '1.75rem' } },
  },
  components: {
    accordion: {
      panel: { borderWidth: '0' },
      header: {
        activeBackground: '{surface.section}', activeHoverBackground: '{surface.section}', hoverBackground: '{surface.section}', background: '{surface.section}',
        borderWidth: '0', borderRadius: '0.5rem', last: { activeBottomBorderRadius: '0.5rem' },
      },
      content: { borderWidth: '0', padding: '1.125rem' },
    },
    button: {
      root: { iconOnlyWidth: '2.3125em' },
      colorScheme: {
        light: { outlined: { primary: { borderColor: '{primary}' } }, text: { secondary: { color: '{button.secondary.color}' } } },
        dark: { outlined: { primary: { borderColor: '{primary}' } }, text: { secondary: { color: '{button.secondary.color}' } } },
      },
    },
    colorpicker: { panel: { borderRadius: '0.5rem' } },
    confirmpopup: { root: { gutter: '4px' } },
    datatable: { paginatorBottom: { borderWidth: '0' } },
    dialog: { root: { borderColor: 'transparent', borderRadius: '2em' } },
    menu: { root: { borderRadius: '1.5rem' }, item: { borderRadius: '2rem' }, list: { padding: '0.5rem 0.5rem' } },
    popover: { root: { gutter: '4px' } },
    splitter: { handle: { background: '{surface.section}' } },
    tabs: { tabpanel: { padding: '1.125rem 0 0' } },
    tieredmenu: { root: { borderRadius: '1.5rem' }, item: { borderRadius: '2rem' }, list: { padding: '0.5rem 0.5rem' } },
    toast: { root: { borderWidth: '0' } },
    tooltip: { root: { borderRadius: '0.5rem', maxWidth: '20rem' } },
  },
});
